import type { Locale } from '@mfw/translations';

import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
  fetchOrganizationMemberProfileTemplate,
  fetchMyOrganizationMemberProfile,
  fetchOrganizationMemberProfile,
} from '../api/organizationMemberProfile.api';

export const organizationMemberProfileQueryKeys = createQueryKeys(
  'organizationMemberProfile',
  {
    fetchMyOrganizationMemberProfile: ({
      locale,
      organizationId,
    }: {
      organizationId: string;
      locale: Locale;
    }) => ({
      queryFn: () =>
        fetchMyOrganizationMemberProfile({ locale, organizationId }),
      queryKey: [organizationId],
    }),
    fetchOrganizationMemberProfile: ({
      locale,
      organizationId,
      userId,
    }: {
      organizationId: string;
      locale: Locale;
      userId: string;
    }) => ({
      queryFn: () =>
        fetchOrganizationMemberProfile({ locale, organizationId, userId }),
      queryKey: [organizationId, userId],
    }),
    fetchOrganizationMemberProfileTemplate: ({
      locale,
    }: {
      locale: Locale;
    }) => ({
      queryFn: () => fetchOrganizationMemberProfileTemplate({ locale }),
      queryKey: ['template'],
    }),
  },
);
